import { useV2GetBlueprintQuery } from "@generated";

export interface BlueprintDetail {
  id: string;
  name: string;
  tagList: string[];
  executiveSummary: string;
  solutionSummary: string;
  rateTableId: string | null;
  paymentTermId: string | null;
  rawPayload: any[];
  dataVersion: string | null;
}

const useGetBlueprint = (id: number) => {
  let customError: string | null = null;

  const { data, error, isLoading, refetch } = useV2GetBlueprintQuery(
    { id: String(id) },
    { skip: !id }
  );

  let blueprint: BlueprintDetail | null = null;

  if (data?.data) {
    try {
      const b = data.data;
      if (!b.id) throw new Error("Missing blueprint.id");
      const defaultProject = {
        lid: crypto.randomUUID(),
        type: "projects",
        attributes: { "executive-summary": "", "solution-summary": "" },
      };
      const rawPayload: any[] = [
        ...((b.attributes as any)?.payload ?? []),
      ].filter((p: any) => p.attributes?.active !== false);
      const project =
        rawPayload.find((p: any) => p.type === "projects") ?? defaultProject;
      if (project?.lid) {
        console.warn(
          `Blueprint ${b.id}: no project entry in payload, assigning default project with lid`
        );
        rawPayload.unshift(project);
      }
      blueprint = {
        id: String(b.id),
        name: b.attributes.name,
        tagList: b.attributes["tag-list"] || [],
        executiveSummary: project?.attributes?.["executive-summary"] || "",
        solutionSummary: project?.attributes?.["solution-summary"] || "",
        rateTableId: project?.relationships?.["rate-table"]?.data?.id ?? null,
        paymentTermId:
          project?.relationships?.["payment-term"]?.data?.id ?? null,
        rawPayload,
        dataVersion: (b.attributes as any)?.["data-version"] ?? null,
      };
    } catch (err) {
      customError =
        err instanceof Error ? err.message : "An unknown error occurred";
    }
  }

  return {
    blueprint,
    blueprintLoading: isLoading,
    error: error ?? customError,
    refetch,
  };
};

export default useGetBlueprint;
